import * as React from "react";
import { Box } from "@mui/material";

/** HTML `.search-bar` */
export default function PlatformSearchRow({ children, sx = {} }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mb: 2.5,
        flexWrap: "wrap",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
